export const INSERIR_ANOTACAO = 'Insira a anotação';
export const VISUALIZAR_PARTIR = 'Visualizar a partir de';
export const COPIAR_ANOTACAO = 'Copiar anotação para todas as empresas do grupo';
export const DATA_FOLLOW_UP = 'Data de Follow up';
export const CONTEUDO = 'Conteúdo';
